import { X } from 'react-feather';

import {
  Button,
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Label,
  LoadingSpinner,
  ScrollArea,
  Textarea,
} from '@shared/ui';

//TODO :should be refactor
import FileUploader from '@/components/ui/uploader/file-uploader';

import { supportWidgetLanguage, useCreateTicket } from '../model';
interface Props {
  isOpen: boolean;
  setIsOpen: (v: boolean) => void;
  onTicketCreated?: () => void;
}

export const CreateTicket = ({ isOpen, setIsOpen, onTicketCreated }: Props) => {
  const logic = useCreateTicket(onTicketCreated, () => setIsOpen(false));

  return (
    <Drawer
      open={isOpen}
      onOpenChange={(open) => {
        setIsOpen(open);
        if (!open) logic.resetForm();
      }}
    >
      <DrawerContent className='flex flex-col justify-between w-full pt-2  mb-5 h-[calc(100svh)] '>
        <DrawerHeader>
          <div className='flex items-center justify-between'>
            <DrawerTitle className='body-13-bold'>{supportWidgetLanguage.createTicket}</DrawerTitle>
            <DrawerClose className='focus-visible:outline-none'>
              <X size={24} strokeWidth={1} />
            </DrawerClose>
          </div>
        </DrawerHeader>{' '}
        <Form {...logic.form}>
          <form onSubmit={logic.form.handleSubmit(logic.onSubmit)} className='flex flex-col'>
            <ScrollArea className='h-[75svh]' dir='rtl'>
              <div className='flex flex-col gap-5 p-3'>
                <FormField
                  name='subject'
                  control={logic.form.control}
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>{supportWidgetLanguage.title}</FormLabel>
                      <FormControl>
                        <Input
                          {...field}
                          type='text'
                          placeholder='عنوان تیکت را وارد کنید'
                          disabled={logic.isLoading}
                          className={`h-[34px]`}
                          maxLength={40}
                          autoComplete='off'
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormField
                  name='description'
                  control={logic.form.control}
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>
                        متن پیام <Label className='text-red-1'>*</Label>
                      </FormLabel>
                      <FormControl>
                        <Textarea {...field} rows={6} maxLength={3000} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FileUploader
                  fileList={logic.fileList}
                  onChange={logic.handleFileChange}
                  uploadFn={logic.uploadFn}
                  maxCount={3}
                  maxSize={3}
                  multiple
                />
                <p className='!text-icons body-10-regular'>
                  * فرمت های مجاز: JPG, JPEG, PNG, PDF, DOC, DOCX, XLS, XLSX, TXT, HEIC, TIFF
                </p>
                <p className='!text-icons body-10-regular'>* سایز مجاز: حداکثر 3 مگابایت</p>

                <div ref={logic.scrollBottomRef} />
              </div>
            </ScrollArea>

            <Button
              type='submit'
              disabled={logic.isLoading}
              data-testid='newticket-submit'
              className='md:px-[32px] md:py-[8px] h-[60px] md:h-auto w-full md:w-auto items-center gap-2 md:mx-0'
            >
              {logic.isLoading && <LoadingSpinner className='scale-75' />}
              {supportWidgetLanguage.send}
            </Button>
          </form>
        </Form>
      </DrawerContent>
    </Drawer>
  );
};
